import { FC, memo } from 'react'

import { Dialog, DialogFace } from 'ui/components/Dialog'
import { Icon, IconName } from 'ui/components/Icon'

import { WarningsProps } from './Warnings.types'

import { s } from './styles'

export const Warnings: FC<WarningsProps> = memo(({ warnings, onClose }) => {
  if (!warnings) {
    return null
  }

  return (
    <Dialog
      face={DialogFace.DEFAULT}
      id="warnings-dialog"
      onClose={onClose}
      title={
        <s.Title>
          <Icon name={IconName.ERROR_RED} /> <span>Warning(s)</span>
        </s.Title>
      }
    >
      <s.Content>
        {warnings.split('\n').map((i: any) => (
          <li key={i}>{i}</li>
        ))}
      </s.Content>
    </Dialog>
  )
})
